const keyCodes = {
	enter: 13,
	up: 38,
	down: 40,
};

const screwButtonsSettings = function (isCheckBox, width, height) {
	const radioButtonImg = "url(/images/art_sprite_radiobtns.png)";
	const checkBoxImg = "url(/images/art_sprite_checkbox.png)";

	return {
		image: isCheckBox ? checkBoxImg : radioButtonImg,
		width: width || 16,
		height: height || 16,
	};
};

const icons = {
	plus: "icon-uni2B",
	minus: "icon-uni2D",
};

export { keyCodes, screwButtonsSettings, icons };
